import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../Navbar/Navbar";
import { FaEdit, FaInfoCircle } from "react-icons/fa";
import { addAlert, getAlert, getAlerts, enableDisableAlert, getAlertTransaction } from "../../Redux/Alert/Action";
import Swal from "sweetalert2";
import Icon from "../utility/Icon";
import { MdOutlineToggleOff, MdOutlineToggleOn } from "react-icons/md";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import Select from "react-select";
import NewDataTable from "../DataTable/NewDataTable";
import "./Alert.css";
import { empList } from "../../Redux/DailyUpdateApproval/Action";

const Alert = () => {

  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const dispatch = useDispatch();
  const { alert, alerts, alertTransaction } = useSelector((state) => state.alert);
  const { emplists } = useSelector((store) => store.dailyUpdateApprover);
  const [show, setShow] = useState(false);
  const [showTransaction, setShowTransaction] = useState(false);
  const [rowData, setRowData] = useState([]);
  const handleClose = () => {
    setShow(false);
    setAlertData(initialAlertData);
  }

  const initialAlertData = {
    alertId: "",
    loginId: loginId,
    subject: "",
    description: "",
    type: "D",
    date: new Date().toISOString().split("T")[0],
    period: "",
    status: "A",
    userId: loginId,
    email: "",
    actionType: "INSERT",
  };

  useEffect(() => {
    dispatch(empList(token, "All"));
  }, []);

  const [alertData, setAlertData] = useState(initialAlertData);


  const handleShow = () => {
    setShow(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.replace(/^\s+/, "");
    setAlertData((values) => ({
      ...values,
      [name]: trimmedValue,
    }));

    if (name === "type") {
      setAlertData((values) => ({
        ...values,
        period: ""
      }))
    }
  };


  const handleDateChange = (date, name) => {
    setAlertData((prevData) => ({
      ...prevData,
      [name]: date ? format(date, "yyyy-MM-dd") : "",
    }));
  };

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  const handelfetchAlertDetails = (alertId) => {
    dispatch(getAlert(alertId, token));
    setShow(true);
  };

  const handelfetchTransDetails = async (row) => {
    dispatch(getAlertTransaction(row.alertId, selectedYear?.value, token));
    setRowData(row);
    setShowTransaction(true);
  };


  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState({
    value: currentYear,
    label: currentYear.toString(),
  });

  const handleTransactionClose = () => {
    setShowTransaction(false);
    setSelectedYear({
      value: currentYear,
      label: currentYear.toString(),
    });
  }


  // Generate last 10 years
  const yearOptions = Array.from({ length: 10 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, label: year.toString() };
  });


  const handleYearChange = (option) => {
    setSelectedYear(option);
  };

  useEffect(() => {
    if (alert && alert.alertDto && alert.alertDto[0]) {
      setAlertData(alert.alertDto[0]);
      setAlertData((values) => ({
        ...values,
        actionType: "UPDATE",
        loginId: loginId,
      }));
    }
  }, [alert]);

  useEffect(() => {
    if (selectedYear) {
      dispatch(getAlertTransaction(rowData.alertId, selectedYear?.value, token));
    }
  }, [dispatch, selectedYear]);


  const handleSubmit = (e) => {
    e.preventDefault();

    if (alertData.type === "S" && alertData.period === "") {
      Swal.fire({
        icon: "warning",
        title: "Alert period is required",
        text: "Please select a period type.",
      });
      return;
    }
    let finalValues;
    if (alertData.type === "D") {
      finalValues = {
        ...alertData,
        period: "D",
      }
    } else {
      finalValues = alertData;
    }

    Swal.fire({
      title: "Are you sure?",
      html: "Do you want to submit the alert details?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(addAlert(finalValues, token))
          .then(({ success, error }) => {
            if (success) {
              handleClose();
              dispatch(getAlerts(loginId, token));
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Alert details submitted successfully.",
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text:
                  // error ||
                  "There was an error submitting the alert details",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error submitting the alert details1.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };


  const enableDisableAlertSubmit = (alertId, status) => {



    Swal.fire({
      title: "Are you sure?",
      html: "Do you want to disable/enable  the alert ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, disable/enable  it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(enableDisableAlert(alertId, status, token))
          .then(({ success, error }) => {
            if (success) {
              handleClose();
              dispatch(getAlerts(loginId, token));
              setAlertData(initialAlertData)
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Alert details disable/enable  successfully.",
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              setAlertData(initialAlertData)
              handleClose();
              Swal.fire({
                title: "Error!",
                text:
                  // error ||
                  "There was an error disable/enable  the alert ",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            setAlertData(initialAlertData)
            handleClose();
            Swal.fire({
              title: "Error!",
              text: "There was an error disable/enable  the alert .",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  const periodData = {
    M: "Monthly",
    Q: 'Quaterly',
    Y: 'Yearly',
    B: 'Once in Two Years',
    T: 'Once in Three Years',
    F: 'Once in Five Years',
  }


  useEffect(() => {
    dispatch(getAlerts(loginId, token));
  }, [loginId, token]);



  const columns = [
    {
      name: "SN",
      cell: (_, index) => index + 1,
      sortable: false,
      width: "80px",
      align: "center",
    },
    {
      name: "Subject",
      selector: (row) => row?.subject || "-",
      sortable: true,
    },
    {
      name: "Period",
      selector: (row) => periodData?.[row?.period] ?? "-",
      sortable: true,
      align: "center",
    },
    {
      name: "Date",
      selector: (row) => row?.date ?? "-",
      sortable: true,
      align: "center",
    },

    {
      name: "Action",
      selector: (row) => row,
      sortable: false,
      width: "226px",
      align: "center",
      cell: (row) => (
        <div>
          <Tooltip text="Edit">
            <Icon
              icon={FaEdit}
              variant="warning"
              className="me-3"
              onClick={() => handelfetchAlertDetails(row.alertId)}
            />
          </Tooltip>

          {row.status === "A" ? (
            <Tooltip text="Disable">
              <Icon
                icon={MdOutlineToggleOn}
                variant="primary"
                onClick={() => enableDisableAlertSubmit(row.alertId, "I")}
              />
            </Tooltip>
          ) : (
            <Tooltip text="Enable">
              <Icon
                icon={MdOutlineToggleOff}
                variant="secondary"
                onClick={() => enableDisableAlertSubmit(row.alertId, "A")}
              />
            </Tooltip>
          )}

          <Tooltip text="History">
            <Icon
              icon={FaInfoCircle}
              variant="success"
              className="ms-3"
              onClick={() => handelfetchTransDetails(row)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];
  const dailyColumns = [
    {
      name: "SN",
      cell: (_, index) => index + 1,
      sortable: false,
      width: "80px",
      align: "center",
    },
    {
      name: "Subject",
      selector: (row) => row?.subject || "-",
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row?.date ?? "-",
      sortable: true,
      align: "center",
    },

    {
      name: "Action",
      selector: (row) => row,
      sortable: false,
      width: "226px",
      align: "center",
      cell: (row) => (
        <div>
          <Tooltip text="Edit">
            <Icon
              icon={FaEdit}
              variant="warning"
              className="me-3"
              onClick={() => handelfetchAlertDetails(row.alertId)}
            />
          </Tooltip>

          {row.status === "A" ? (
            <Tooltip text="Disable">
              <Icon
                icon={MdOutlineToggleOn}
                variant="primary"
                onClick={() => enableDisableAlertSubmit(row.alertId, "I")}
              />
            </Tooltip>
          ) : (
            <Tooltip text="Enable">
              <Icon
                icon={MdOutlineToggleOff}
                variant="secondary"
                onClick={() => enableDisableAlertSubmit(row.alertId, "A")}
              />
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  const transactionColumns = [
    {
      name: "SN",
      cell: (_, index) => index + 1,
      sortable: false,
      width: "80px",
      align: "center",
    },
    {
      name: "Due Date",
      selector: (row) => row.dueDate,
      sortable: true,
      align: "center",
    },
    {
      name: "Completed On",
      selector: (row) => format(row.completionDateTime, "dd MMM yyyy, hh.mm a"),
      sortable: true,
      align: "center",
    },
  ];


  const statutoryList = alerts.alertDto?.filter(item => item.type === 'S') || [];

  const dailyList = alerts.alertDto?.filter(item => item.type === 'D') || [];

  const transList = alertTransaction?.alertTransactionDtoList || [];



  return (
    <div>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid mt-4">

          <div className="card3">
            <div className="card-body">
              <div className="d-flex justify-content-between mb-3">
                <h5 className="left-header">ALERT</h5>
                <button className="btn btn-primary" onClick={handleShow} style={{ width: "150px" }}
                >
                  ADD NEW
                </button>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="card shadow-sm h-100 rounded-4">
                    <div className="card-body" style={{ minHeight: "400px" }}>
                      <div>
                        <NewDataTable
                          columns={columns}
                          data={statutoryList || []}
                          tableName="STATUTORY"
                          defaultRowsPerPage={6}
                        />

                      </div>
                    </div>
                  </div>
                </div>


                <div className="col-md-6">
                  <div className="card shadow-sm h-100 rounded-4">
                    <div className="card-body" style={{ minHeight: "400px" }}>
                      <div >
                        <NewDataTable
                          columns={dailyColumns}
                          data={dailyList || []}
                          tableName="DAILY"
                          defaultRowsPerPage={6}
                        />
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>

        </div>
      </div>
      <div
        className={`modal fade alert-modal ${show ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ backgroundColor: show ? "rgba(0,0,0,0.5)" : "transparent" }}
      >
        <div
          className="modal-dialog modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{alertData?.actionType === "INSERT" ? "ADD " : "EDIT "}ALERT DETAILS</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row">

                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="projectCode">
                        <b>Alert Type</b><span className="text-danger">*</span>
                      </label>
                      <select
                        name="type"
                        value={alertData.type || ""}
                        onChange={handleChange}
                        id="type"
                        className="form-select"
                        required
                      >
                        <option value="">Choose Option...</option>

                        <option value="D">Daily</option>
                        <option value="S">Statutory</option>


                      </select>
                    </div>
                  </div>


                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="date">
                        <b>Alert Date</b><span className="text-danger">*</span>
                      </label>
                      <DatePicker
                        selected={alertData.date ? new Date(alertData.date) : null}
                        onChange={(date) => handleDateChange(date, "date")}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        placeholderText="Date"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        onKeyDown={(event) => event.preventDefault()}
                      />
                    </div>
                  </div>

                  {alertData.type === "S" && (
                    <div className="col-md-5">
                      <div className="form-group">
                        <label htmlFor="period">
                          <b>Alert Period</b><span className="text-danger">*</span>
                        </label>
                        <select
                          name="period"
                          value={alertData.period || ""}
                          onChange={handleChange}
                          id="period"
                          className="form-select"
                        >
                          <option value="">Choose Period...</option>


                          <option value="M">Monthly</option>
                          <option value="Q">Quarterly</option>
                          <option value="Y">Yearly</option>
                          <option value="B">Once in Two Years</option>
                          <option value="T">Once in Three Years</option>
                          <option value="F">Once in Five Years</option>

                        </select>

                      </div>
                    </div>
                  )}
                  {alertData.type === "D" && (
                    <div className="col-md-5">
                      <div className="form-group">

                        <label
                          htmlFor="email"
                          className="form-label"
                          id="email"
                        >
                          Alert for External Email
                        </label>
                        <select
                          name="email"
                          value={alertData.email || ""}
                          onChange={handleChange}
                          id="email"
                          className="form-select"
                        >
                          <option value="">Choose Option...</option>
                          {[...emplists]
                            .filter(emp => emp.personalEmail)   // remove null/empty emails
                            .sort((a, b) => a.personalEmail.localeCompare(b.personalEmail))
                            .map((emp, index) => (
                              <option key={index} value={emp.personalEmail}>
                                {emp.personalEmail}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                  )}




                </div>
                <div className="form-group mb-3">
                  <label htmlFor="subject">
                    <b>Subject</b><span className="text-danger">*</span>
                  </label>
                  <textarea
                    type="text"
                    id="subject"
                    className="form-control"
                    name="subject"
                    rows={3}
                    value={alertData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="text-center">
                  <button type="submit" className="btn btn-success">
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade alert-modal ${showTransaction ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ backgroundColor: showTransaction ? "rgba(0,0,0,0.5)" : "transparent" }}
      >
        <div
          className="modal-dialog modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header d-flex align-items-center justify-content-between">

              <h5 className="modal-title mb-0">ALERT TRANSACTION</h5>


              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center me-4">
                  <b>
                    <label className="me-2 mb-0 text-dark fs-6">Year:</label>
                  </b>
                  <div style={{ width: "120px" }}>
                    <Select
                      options={yearOptions}
                      value={selectedYear}
                      onChange={handleYearChange}
                      placeholder="Select Year"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </div>
                </div>

                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={handleTransactionClose}
                ></button>
              </div>
            </div>



            <div className="modal-body">
              <div className="d-flex align-items-center">
                <strong className="me-1">Subject: </strong>
                <p className="mb-0">{rowData?.subject ?? ""}</p>
              </div>

              <div >

                <NewDataTable
                  columns={transactionColumns}
                  data={transList || []}
                  tableName="TRANSACTION LIST"
                  defaultRowsPerPage={5}
                />
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Alert;